import { UserInfo, UserRoles } from '../models/user';

export const getHighestRole = (roles = []) => {
  if (roles.indexOf(UserRoles.Admin) > -1) return UserRoles.Admin;
  if (roles.indexOf(UserRoles.Manager) > -1) return UserRoles.Manager;
  return UserRoles.Agent;
};

export const compareRoles = (firstUserRole, secondUserRole) => {
  if (firstUserRole === UserRoles.Admin)
    return true;
  if (firstUserRole === UserRoles.Manager)
    return secondUserRole !== UserRoles.Admin;
  return false;
};

export const isActionAllowed = (firstUser: UserInfo, secondUser: UserInfo) => {
  const highestFirstUserRole = getHighestRole(firstUser?.roles);
  const highestSecondUserRole = getHighestRole(secondUser?.roles);
  return compareRoles(highestFirstUserRole, highestSecondUserRole);
};
